import { ExternalPolice, PoliceStation } from "types";
import apiClient from "../lib/apiClients";
import axios from "axios";

// External Police User List
export const fetchExternalPolice = async () => {
  const response = await apiClient.get<ExternalPolice[]>(
    "/external_usermngt/external-police-users/"
  );
  return response.data;
};
export const addExternalPolice = async (data: any) => {
  const response = await apiClient.post(
    "/external_usermngt/external-police-users/",
    data
  );
  return response.data;
};
export const editExternalPolice = async (data: any) => {
  const response = await apiClient.put(
    "/external_usermngt/external-police-users/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deleteExternalPolice = async (data: ExternalPolice) => {
  const response = await apiClient.delete(
    "/external_usermngt/external-police-users/" + data?.id + "/"
  );
  return response.data;
};

// Client management API base (client/police stations + client login).
const CLIENT_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL_3 || process.env.REACT_APP_API_BASE_URL_POLICE;

// Police Stations List
export const fetchPoliceStation = async () => {
  const response = await axios.get<PoliceStation[]>(
    `${CLIENT_API_BASE_URL}client_managements/clients/`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
      },
    }
  );
  return response.data;
};
export const addPoliceStation = async (data: PoliceStation) => {
  const response = await apiClient.post(
    "/external_usermngt/police-stations/",
    data
  );
  return response.data;
};
export const editPoliceStation = async (data: PoliceStation) => {
  const response = await apiClient.put(
    "/external_usermngt/police-stations/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deletePoliceStation = async (data: PoliceStation) => {
  const response = await apiClient.delete(
    "/external_usermngt/police-stations/" + data?.id + "/"
  );
  return response.data;
};
